export enum CompanyStatusEnum {
  OTHER = 0,
  PRE_REGISTRATION = 2,
  ACTIVE = 3,
  IN_INACTIVITY = 4,
  BANKRUPTCY = 5,
  SOLUTION_CLEARANCE = 7,
  CONCILIATION_PROCEDURE = 15,
  DELETE = 17,
  DELETION_DUE_TO_MERGER = 18,
  FORCED_MANAGEMENT = 19,
  DELETION_DUE_TO_DIVISION = 20,
  SUSPENSION_OF_ENTRY = 21,
}
